import { render, staticRenderFns } from "./onepage.vue?vue&type=template&id=62f08a3a&"
import script from "./onepage.vue?vue&type=script&lang=js&"
export * from "./onepage.vue?vue&type=script&lang=js&"
import style0 from "./onepage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports